import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './Overview.styles';
import { getOverviewData } from './Overview.helpers';
import { OverviewData } from './Overview.types';
import { useAdDetails } from '@/views/Ads/useAdDetails';
import NoSsr from '@/components/NoSsr/NoSsr';
import { useServerDataContext } from '@/contexts';
import { Advertise } from '@/components/Ad/Promotions/Advertise';

export const Overview: React.FC = () => {
  const { i18n } = useTranslation();
  const { adDetails } = useAdDetails();
  const { initialAdDetails } = useServerDataContext();
  const adData = adDetails ?? initialAdDetails;
  const overviewData = adData
    ? getOverviewData(i18n, adData)
    : Array.from({ length: 3 }, (_, index) => ({ id: index } as OverviewData));

  return (
    <S.OverviewBox
      {...(!adData && { 'data-testid': 'overview-skeleton-loader' })}
    >
      <S.OverviewInfoContainer>
        {overviewData.map(({ id, name, value, isDateTime }, index) => {
          const isLast = index === overviewData.length - 1;
          const Wrapper = isDateTime ? NoSsr : React.Fragment;
          return (
            <Wrapper key={id}>
              <S.Item>
                {name} {value}
              </S.Item>
              {!isLast && <S.DotIcon $width={4} $height={4} />}
            </Wrapper>
          );
        })}
      </S.OverviewInfoContainer>
      <Advertise />
    </S.OverviewBox>
  );
};
